export class OpenDialog {
	el: HTMLButtonElement | HTMLLinkElement;

	constructor(el: HTMLButtonElement | HTMLLinkElement) {
		this.el = el;

		el.addEventListener('click', (e) => {
			const dialogId = el.dataset.openDialog;

			if (!dialogId) {
				return;
			}

			const dialog = document.querySelector(`dialog#${dialogId}`) as
				| HTMLDialogElement
				| undefined;

			if (dialog && 'showModal' in dialog) {
				e.preventDefault();

				dialog.showModal();
			}
		});
	}
}

export default class Dialog {
	el: HTMLDialogElement;
	closeButton?: HTMLButtonElement | null;

	constructor(el: HTMLDialogElement) {
		this.el = el;
		this.closeButton = el.querySelector('[data-dialog-close]');

		if (this.closeButton) {
			this.closeButton.addEventListener('click', this.closeHandler.bind(this));
		}
		// Close dialog when clicking outside.
		this.el.addEventListener('click', (e) => {
			if (e.target === this.el) {
				this.closeHandler();
			}
		});
	}

	closeHandler() {
		this.el.close();
	}
}
